// extracted by mini-css-extract-plugin
module.exports = {"step":"newDevice_step__1Irm5","icons":"newDevice_icons__YVSHL"};